import React, { useCallback, useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { DepositPanel } from 'pages/NewDashboard/components/DepositPanel';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { Vault, VAULTS } from 'data/Vaults';
import { ItemCard } from 'pages/Landing/components/ItemCard';
//import { useEthersSigner } from 'hooks/useEtherSigner';
import {
	fetchInsightsRequest,
	resetInsights,
} from 'store/insights/insightsSaga';
import { styled } from '@mui/system';
import { getClaimList, UserWithdrawDeposit } from 'apis';
import { AGENT, BLANK_ACCOUNT } from 'data/constant';
import { Header } from 'pages/NewDashboard/components/Header';
import { AccountType } from 'types/distribution';
import { RewardClaim } from 'pages/NewDashboard/components/RewardClaim';
import { TVLHeader } from 'pages/NewDashboard/components/TVLHeader';
import { useAptosWalletContext } from 'context/aptosProvider';

const TopLine = styled('div')`
	position: absolute;
	top: -2px;
	left: 16.5px;
	width: 1px;
	height: 25px;
	background-color: rgb(138, 140, 146);
	transform: rotate(45deg);
	transform-origin: left top;
	z-index: 13;
`;

const BottomLine = styled('div')`
	position: absolute;
	width: 1px;
	height: 25px;
	background-color: rgb(138, 140, 146);
	transform: rotate(45deg);
	transform-origin: left top;
	z-index: 13;
	bottom: -9px;
	right: -0.5px;
`;

const Wrapper = styled('div')`
	display: grid;
	backdrop-filter: blur(20px);
	grid-template-columns: 1fr 1fr /* 1fr*/;
	column-gap: 20px;
	row-gap: 20px;
	width: 100%;
	height: 100%;
	padding: 0;
	border-radius: 20px;
	max-width: 1250px;

	@media (max-width: 1400px) {
		border-radius: 0;
	}

	@media (max-width: 1100px) {
		grid-template-columns: 1fr;
		border-radius: 20px;
		width: fit-content;
	}
`;

const Column = styled('div')`
	display: flex;
	flex-direction: column;
	height: 100%;
`;

const StyledRow = styled('div')`
	display: flex;
	flex: 1 1;
	flex-direction: row;
	flex-wrap: nowrap;
	width: 100%;
	justify-content: center;
	align-items: center;
	gap: 0;
	height: 100%;
`;

const Main = styled('div')`
	display: flex;
	flex-direction: column;
	align-items: center;
	//justify-content: center;
	background-color: #f3f3f3;
	height: 100%;
	flex: 1;
`;

const Withdraw = styled('div')`
	display: flex;
	flex-direction: column;
	width: 100%;
	//max-width: 500px;
	height: 100%;
	padding: 0 10px 40px 10px;
`;

const AgentWrapper = styled('div')`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	padding: 32px 0;
	background-color: white;
`;

const BorderBox = styled(Withdraw)`
	position: relative;
	height: 100%;
	background-color: #fff;
	clip-path: polygon(
		15px 0,
		100% 0,
		100% calc(100% - 15px),
		calc(100% - 15px) 100%,
		0 100%,
		0 15px
	);

	&:before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		border: 1px solid #8a8c92;
		clip-path: inherit;
		pointer-events: none;
	}
	padding: 20px;
`;

/*const Flex = styled('div')`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background-color: #f3f3f3;
	padding-bottom: 30px;
	width: 100%;
`;*/

const Body = styled('div')`
	padding-top: 80px;
	width: 100%;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
`;

export const NewDashboard = () => {
	const [contractBal, setContractBal] = useState('0');
	const [accountInformation, setAccountInformation] =
		useState<AccountType | null>(BLANK_ACCOUNT);

	// const [withdrawAddress, setWithdrawAddress] = useState(WITHDRAW_ADDRESS);
	const [claims, setClaims] = useState<UserWithdrawDeposit[]>([]);
	const selectedVault = useSelector((state: RootState) => state.vault);
	const dispatch = useDispatch();
	const appState = useSelector((state: RootState) => state.app);
	const selectedExchange = selectedVault.exchanger.find(
		(d) => d.value === selectedVault.exchange,
	);
	const { account } = useAptosWalletContext();
	const selectedAsset = selectedVault.token.find(
		(d) => d.name === selectedVault.selectedToken,
	);
	const appVault = useSelector((state: RootState) => state.vault);
	const selectedContract = selectedVault.exchanger.find(
		(d) => d.value === appVault.exchange,
	);
	//const signer: any = useEthersSigner();

	/*	const getWithdrawAddress = useCallback(async () => {
		try {
			const depContract = getDepositContract(
				selectedExchange?.depositContractAddress || '',
				signer?.provider.getSigner(account).connectUnchecked(),
			);

			const withdrawContractAddress =
				await depContract.getWithdrawManager();

			setWithdrawAddress(withdrawContractAddress);

			return;
		} catch (e: any) {
			//
		}
	}, [account, selectedExchange?.depositContractAddress, signer?.provider]);*/

	const fetchClaims = useCallback(async () => {
		try {
			if (account) {
				const res = await getClaimList(
					selectedExchange?.depositContractAddress || '',
					account,
				);

				setClaims(res);
			} else {
				setClaims([]);
			}
		} catch (e) {
			//
		}
	}, [account, selectedExchange?.depositContractAddress]);

	const fetchContractBalance = useCallback(
		async () => {
			/*	try {
			const address = selectedExchange?.depositContractAddress;
			if (!account || !address) {
				setContractBal('0');
				return;
			}

			dispatch(
				appActions.setLoading({
					loading: true,
					message: 'Please Wait...',
				}),
			);

			const isClaim = claims.filter((f) => f.eventType === 'claim');

			/!*const provider = signer?.provider
				.getSigner(account)
				.connectUnchecked();*!/

			/!*const contract = selectedAsset?.isNative
				? getNativeDepositContract(address, provider)
				: getDepositContract(address, provider);*!/

			const { shareBalance, assetBalance } =
				await contract.getUserBalance(account);

			const decimals = selectedAsset?.decimalValue ?? 6;
			const shared = selectedAsset?.isNative
				? ethers.utils.formatUnits(shareBalance.toString(), decimals)
				: toDecimal(shareBalance.toString(), decimals).toString();
			const asset = selectedAsset?.isNative
				? ethers.utils.formatUnits(assetBalance.toString(), decimals)
				: toDecimal(assetBalance.toString(), decimals).toString();

			setContractBal(
				isClaim.length > 0
					? (
							parseFloat(shared || '0') + parseFloat(asset || '0')
					  ).toString()
					: shared,
			);
			//setContractBal(isClaim ? asset : shared);
		} catch (e) {
			//
		} finally {
			dispatch(appActions.setLoading({ loading: false, message: '' }));
		}*/
		},
		[
			/*account,
		claims,
		dispatch,
		selectedAsset?.decimalValue,
		selectedAsset?.isNative,
		selectedExchange?.depositContractAddress,
		signer?.provider,*/
		],
	);

	/*const fetchAccountInformation = async (
		account: string | undefined,
		contractAddress: string | undefined,
	) => {
		try {
			if (account) {
				const res = await getUserAccountInformation({
					address: account.toLowerCase(),
					contract: contractAddress?.toLowerCase() || '',
				});
				setAccountInformation(res);
			} else {
				setAccountInformation(BLANK_ACCOUNT);
			}
		} catch (error) {
			console.error('Failed to fetch account info:', error);
		}
	};*/

	/*const getGraphQl = useCallback(async () => {
		try {
			const data = await getUserDetails();
			console.log(data, 'lp');
		} catch (e) {
			//
		}
	}, []);*/

	useEffect(() => {
		dispatch(fetchInsightsRequest());

		return () => {
			dispatch(resetInsights());
		};
	}, [dispatch]);

	/*useEffect(() => {
		getGraphQl();
	}, [getGraphQl]);*/

	useEffect(() => {
		fetchClaims();
	}, [fetchClaims]);

	/*useEffect(() => {
		getWithdrawAddress();
	}, [getWithdrawAddress]);*/

	useEffect(() => {
		fetchContractBalance();
	}, [fetchContractBalance]);

	/*	useEffect(() => {
		fetchAccountInformation(
			account,
			selectedContract?.depositContractAddress,
		);
	}, [account, selectedContract?.depositContractAddress]);*/

	return (
		<Body>
			<>
				<AgentWrapper>
					<Typography
						display={'inline'}
						fontFamily={'AtAmiga'}
						variant={'h3'}
					>
						AI AGENT{' '}
						<Typography
							color={'#275FF1'}
							display={'inline'}
							fontFamily={'AtAmiga'}
							variant={'h3'}
						>
							{AGENT.toUpperCase()}
						</Typography>
					</Typography>
				</AgentWrapper>
				<Main>
					<TVLHeader contractBal={contractBal} />
					<Box height={20} />
					{/*<Header stat={stat} contractBal={contractBal} />
					 */}
					<Wrapper>
						<Header
							contractBal={contractBal}
							claims={claims}
							onSuccess={() => {
								fetchClaims();
								fetchContractBalance();
							}}
						/>
						<BorderBox
							style={{
								paddingLeft: 20,
								alignItems: 'center',
								textAlign: 'center',
							}}
						>
							<BottomLine />
							<TopLine />
							<RewardClaim
								contractBal={contractBal}
								claims={claims}
								accountInformation={accountInformation}
								onSuccess={() => {
									/*fetchAccountInformation(
										account,
										selectedContract?.depositContractAddress,
									)*/
								}}
							/>
						</BorderBox>

						<BorderBox style={{ paddingLeft: 20 }}>
							<BottomLine />
							<TopLine />
							<Typography variant={'subtitle2'}>
								Deposit
							</Typography>
							<Box height={16} />
							<DepositPanel
								userContractBalance={contractBal}
								onSuccess={() => {
									fetchContractBalance();
								}}
							/>
						</BorderBox>
						<BorderBox>
							<TopLine />
							<BottomLine />
							<Column>
								<StyledRow>
									{VAULTS[appState.selectedNetwork].map(
										(vault: Vault) => (
											<ItemCard
												accountInformation={
													accountInformation
												}
												key={vault.name}
												{...vault}
											/>
										),
									)}
								</StyledRow>
							</Column>
						</BorderBox>
					</Wrapper>
				</Main>
			</>
		</Body>
	);
};
